import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Typist from 'react-typist';
import FrontPageServices from '../components/FrontPageServices';
import FrontPageAbout from '../components/FrontPageAbout';
import FrontPageContact from '../components/FrontPageContact';
import FrontPageTechnology from '../components/FrontPageTechnology';
import FrontPageOffer from '../components/FrontPageWhyHire';
import Seo from '../components/Seo';
import TypistLoop from '../components/TypistLoop';
import config from '../siteConfig';

const pageSeo = {
  title: `${config.siteTitle} \u2022 ${config.siteShortDescription}`,
  description: config.siteDescription,
};

const IndexPage = ({ data }) => (
  <div className="front-page">
    <Seo pageSeo={pageSeo} />
    <section className="front-page--hero">
      <Img
        alt="Image of Jody Boucher"
        className="front-page--hero-image front-page--hero-landscape"
        sizes={data.landscapeImage.sizes}
      />
      <Img
        alt="Image of Jody Boucher"
        className="front-page--hero-image front-page--hero-portrait"
        sizes={data.portraitImage.sizes}
      />
      <div className="front-page--hero-overlay">
        <h1>
          <TypistLoop startDelay={3000} delayGenerator={() => 60}>
            I build web sites and applications that are secure.
            <Typist.Backspace count={7} delay={4000} />
            scalable.
            <Typist.Backspace count={9} delay={4000} />
            manageable.
            <Typist.Delay ms={8000} />
          </TypistLoop>
        </h1>
      </div>
    </section>
    <FrontPageAbout image={data.aboutImage} />
    <FrontPageServices />
    <FrontPageTechnology />
    <FrontPageOffer />
    <FrontPageContact image={data.contactImage} />
  </div>
);

IndexPage.propTypes = {
  data: PropTypes.shape({
    landscapeImage: PropTypes.object.isRequired,
    portraitImage: PropTypes.object.isRequired,
    contactImage: PropTypes.object.isRequired,
    aboutImage: PropTypes.object.isRequired,
  }).isRequired,
};

export default IndexPage;

export const query = graphql`
  query FrontPageQuery {
    landscapeImage: imageSharp(id: { regex: "/src.images.jody-landscape/" }) {
      sizes(maxWidth: 1268) {
        ...GatsbyImageSharpSizes
      }
    }
    portraitImage: imageSharp(id: { regex: "/src.images.jody-portrait/" }) {
      sizes(maxWidth: 800) {
        ...GatsbyImageSharpSizes
      }
    }
    contactImage: imageSharp(id: { regex: "/src.images.contact/" }) {
      resolutions(width: 300) {
        ...GatsbyImageSharpResolutions
      }
    }
    aboutImage: imageSharp(id: { regex: "/src.images.bg1/" }) {
      sizes(maxWidth: 300) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js